<template lang="pug">
  v-card
    v-card-content
      h2.card-title {{ name }}
    table.table
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.ingredient' | translate }}
          th.table__cell {{ 'base.amount_for_mix' | translate }} [%]
      tbody
        tr.table__row(
          v-for="(item, index) in items"
          :key="index")
          td.table__cell {{ item.ingredient_name }}
          td.table__cell {{ item.percent }} %
    v-divider
    v-card-actions
      .cols-x
        .cols-x__2
          v-btn(
            @click="mixFodder")
            | {{ 'base.mix' | translate }}
        .cols-x__2
          v-input.m-none(
            :label="'base.weight' | translate"
            v-model="amount")
</template>

<script>
import api from '@/api'
import { mapActions } from 'vuex'

export default {
  name: 'MixFodderDialog',
  props: {
    currentItem: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    name: '',
    items: [],
    amount: 0,
    loaded: false
  }),

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('recipes', [
      'getRecipe'
    ]),

    async loadData () {
      // const id = this.$route.params.fodder_id
      const id = this.currentItem.recipe
      this.data = await this.getRecipe(id)
      this.name = this.data.ingredient_name
      this.items = this.data.ingredients
      this.loaded = true
    },

    async mixFodder () {
      const payload = {
        recipe: {
          id: this.currentItem.recipe
        },
        amount: this.amount
      }
      const { errors } = await api.recipes.craft(payload)
      if (!errors) {
        this.$emit('updated')
        this.close()
      } else {
        if (errors.non_field_errors) {
          if (errors.non_field_errors[0] === '132') {
            this.$toasted.error(this.$t('errors.no_ingredients'))
          }
        } else {
          this.$toasted.error(this.$t('errors.bad_data'))
        }
      }
    },

    close () {
      this.$emit('on-close')
    }
  }
}
</script>
